import { Box, Heading, Text, VStack } from "@chakra-ui/react";

import { EdgePrimitive, NodePrimitive } from "@/design-system/primitives";

interface SectionHeadingProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly body?: string;
  readonly align?: "start" | "center";
}

export function SectionHeading({
  eyebrow,
  title,
  body,
  align = "start"
}: SectionHeadingProps) {
  return (
    <VStack
      position="relative"
      align={align}
      maxW={align === "center" ? "720px" : "620px"}
      mx={align === "center" ? "auto" : undefined}
      spacing={3}
      textAlign={align}
    >
      <EdgePrimitive
        tone="blue"
        top="10px"
        left={align === "center" ? "20%" : "0"}
        right={align === "center" ? "20%" : "auto"}
        w={align === "center" ? undefined : "120px"}
        opacity={0.32}
      />
      <Text
        position="relative"
        color="nvp.cyan"
        fontSize="sm"
        fontWeight={900}
        textTransform="uppercase"
        textShadow="0 0 18px rgba(55,213,255,0.45)"
      >
        <NodePrimitive as="span" tone="pink" position="relative" display="inline-block" mr={2} />
        {eyebrow}
      </Text>
      <Heading
        as="h2"
        fontSize={{ base: "2rem", md: "3rem" }}
        lineHeight={1}
        maxW="820px"
        textShadow="0 0 24px rgba(255,255,255,0.1)"
      >
        {title}
      </Heading>
      {body ? (
        <Box color="whiteAlpha.700" fontSize={{ base: "md", md: "lg" }}>
          {body}
        </Box>
      ) : null}
    </VStack>
  );
}
